import config from "config/config";
import { getToken } from "js/formatting/getToken";
export async function saveAgentAssistant(
  managerAgentId,
  managerAlternateId,
  managerIdentityNumber,
  firstName,
  lastName,
  mobileNumber,
  emailId,
  postalCode,
  viewCommissions
) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      ManagerAgentId: managerAgentId,
      ManagerAlternateId: managerAlternateId,
      ManagerIdentityNumber: managerIdentityNumber,
      FirstName: firstName,
      LastName: lastName,
      MobileNumber: mobileNumber,
      EmailId: emailId,
      PostalCode: postalCode,
      ViewCommissions: viewCommissions,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/agentassistant",
    options
  );
  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
